import "./authInterceptor"; // Auto sign-out on invalid/expired JWT
import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import "./assets/css/materialdesignicons.min.css";
import ChunkErrorFallback from "./components/common/ChunkErrorFallback";
import ProtectedSection from "./components/common/ProtectedSection";
import ScrollToTop from "./components/common/scrollToTop";
import routes from "./routes";
import {
  isStaleDeployError,
  reloadForNewDeploy,
} from "./utils/reloadForNewDeploy";
import "./theme.scss";

class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (isStaleDeployError(error)) {
      reloadForNewDeploy();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ChunkErrorFallback onReload={() => window.location.reload()} />
      );
    }
    return this.props.children;
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <Router>
          <ScrollToTop />
          <ChunkErrorBoundary>
            <Switch>
              {routes.map((route, idx) => (
                <Route
                  exact
                  path={route.path}
                  component={() => (
                    <ProtectedSection>{<route.component />}</ProtectedSection>
                  )}
                  key={idx}
                />
              ))}
            </Switch>
          </ChunkErrorBoundary>
        </Router>
      </React.Fragment>
    );
  }
}

export default withRouter(App);
